import React, { useState } from 'react';
import { X, BookOpen } from 'lucide-react';
import { ConductRulesMatrix } from '../../ConductRulesMatrix';

type TabType = 'rules' | 'process';

interface ConductRulesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ConductRulesModal({ isOpen, onClose }: ConductRulesModalProps) {
  const [activeTab, setActiveTab] = useState<TabType>('rules');

  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white max-w-7xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header fixe */}
        <div className="flex items-center justify-between p-4 border-b bg-white shrink-0">
          <h2 className="text-xl font-bold text-gray-900 flex items-center justify-center gap-2">
            <BookOpen size={20} className="text-gray-600" />
            Referee reference
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1 hover:bg-gray-100"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Navigation par onglets */}
        <div className="flex border-b">
          <button
            onClick={() => setActiveTab('rules')}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'rules'
                ? 'text-blue-600 border-blue-600 bg-blue-50'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Code of Conduct
          </button>
          <button
            onClick={() => setActiveTab('process')}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'process'
                ? 'text-blue-600 border-blue-600 bg-blue-50'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Decision process
          </button>
        </div>

        {/* Contenu scrollable */}
        <div className="flex-1 overflow-y-auto">
          {activeTab === 'rules' ? (
            <ConductRulesMatrix />
          ) : (
            <div className="p-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/decisionProcess.svg`}
                alt="Decision process"
                className="w-full h-auto max-h-[600px] object-contain"/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}